'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _categories = require('./categories.component');

var _categories2 = _interopRequireDefault(_categories);

var _categoryForm = require('./category-form/category-form.module');

var _categoryForm2 = _interopRequireDefault(_categoryForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.categories', [_angularUiRouter2.default, _categoryForm2.default]).component('categories', _categories2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('categories', {
    parent: 'admin',
    url: '/categories',
    component: 'categories',
    resolve: {
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/categories/categories.module.js